/**
 * Human-readable labels for Tracey tool calls shown in the chat while the agent
 * works. Keep in sync with the agent's TOOLS list (TT-agent graph.py). Any tool
 * not listed falls back to a humanised version of its name, so a new tool still
 * reads sensibly instead of showing raw snake_case.
 */
export const TOOL_DESCRIPTIONS = {
  // Core Tendertrace tools
  get_search_summary: 'Searching notices',
  search_tenders: 'Searching notices',
  get_tender_by_search: 'Finding notice',
  get_tender_notice: 'Analysing notice',
  get_leaderboard: 'Analysing leaderboard',
  get_market_insights: 'Analysing market insights',
  save_search: 'Saving search',
  run_saved_search: 'Running saved search',
  get_user_profile_details: 'Analysing your profile',
  get_user_saved_searches: 'Analysing your saved searches',
  get_user_lists: 'Analysing your lists',
  get_user_history: 'Analysing your activity',
  get_pipelines_list: 'Analysing your pipelines',
  get_pipeline_details: 'Analysing pipeline',
  get_pipeline_contracts: 'Analysing pipeline contracts',
  create_pipeline: 'Creating pipeline',
  add_tender_to_pipeline: 'Adding to pipeline',
  get_user_clusters: 'Analysing your clusters',
  get_cluster_contracts: 'Analysing cluster',
  create_cluster: 'Creating cluster',
  add_entities_to_cluster: 'Adding entities to cluster',
  generate_pdf_report: 'Generating PDF report',

  // Fiscal intelligence tools
  get_budget_appropriation: 'Analysing budget appropriations',
  get_myefo_revisions: 'Analysing MYEFO revisions',
  get_underspend_analysis: 'Analysing budget underspend',
  get_forward_estimates: 'Analysing forward estimates',
  get_budget_opportunities: 'Finding budget opportunities',
  get_strategic_priorities: 'Analysing strategic priorities',
  compare_strategy_to_procurement: 'Comparing strategy to procurement',
  get_ipp_compliance: 'Analysing IPP compliance',
  get_procurement_forecast: 'Forecasting procurement',
  get_expiry_vs_budget: 'Analysing contract expiry vs budget',

  // AIIA policy intelligence tools
  get_aiia_policy_position: 'Analysing AIIA policy position',
  list_aiia_documents: 'Listing AIIA documents',

  // Victorian Government intelligence tools
  get_vic_account_brief: 'Building Victorian account brief',
  get_silver_review_reforms: 'Analysing Silver Review reforms',
  get_vic_budget_priorities: 'Analysing Victorian Budget priorities',
  list_vic_documents: 'Listing Victorian documents',
};

/** Turn an unmapped tool name (snake_case) into a readable fallback label. */
function humanise(name) {
  if (!name) return 'Working';
  return String(name)
    .replace(/_/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/^\w/, (c) => c.toUpperCase());
}

export function describeTool(name) {
  return TOOL_DESCRIPTIONS[name] || humanise(name);
}
